import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isMainTabRoute } from "../../layouts/mainTabRoutes";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (isMainTabRoute(pathname)) return;
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, search, hash]);

  return null;
}


